var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 1500 1500" },
      attrs: {
        width: "100%",
        height: "100%",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        x: "0",
        y: "0",
        viewBox: "0 0 1500 1500",
        "xml:space": "preserve",
      },
    },
    [
      _c("g", { attrs: { transform: "translate(210 205) scale(10.66)" } }, [
        _c("defs", [
          _c("path", {
            attrs: {
              id: "SVGID_1_",
              d: "M-5631.8-5631.8H5731.8V5731.8H-5631.8z",
            },
          }),
        ]),
        _c("clipPath", { attrs: { id: "SVGID_2_" } }, [
          _c("use", {
            staticStyle: { overflow: "visible" },
            attrs: { "xlink:href": "#SVGID_1_" },
          }),
        ]),
        _c("g", { staticStyle: { "clip-path": "url(#SVGID_2_)" } }, [
          _c("circle", {
            staticStyle: { fill: "#eee" },
            attrs: { cx: "50", cy: "50", r: "50" },
          }),
        ]),
      ]),
      _c("defs", [
        _c("path", { attrs: { id: "SVGID_3_", d: "M726 160h607v808H726z" } }),
      ]),
      _c("clipPath", { attrs: { id: "SVGID_4_" } }, [
        _c("use", {
          staticStyle: { overflow: "visible" },
          attrs: { "xlink:href": "#SVGID_3_" },
        }),
      ]),
      _c(
        "g",
        { staticStyle: { "clip-path": "url(#SVGID_4_)" } },
        [
          _c(
            "linearGradient",
            {
              attrs: {
                id: "SVGID_5_",
                gradientUnits: "userSpaceOnUse",
                x1: "769",
                y1: "936.85",
                x2: "1288.3",
                y2: "936.85",
                gradientTransform: "matrix(1 0 0 -1 0 1500)",
              },
            },
            [
              _c("stop", {
                staticStyle: { "stop-color": "#eee" },
                attrs: { offset: "0" },
              }),
              _c("stop", {
                staticStyle: { "stop-color": "#d2d4d6" },
                attrs: { offset: "1" },
              }),
            ],
            1
          ),
          _c("path", {
            staticStyle: { fill: "url(#SVGID_5_)" },
            attrs: { d: "M769 202.9h519.3v720.5H769z" },
          }),
          _c("path", {
            staticClass: "st4",
            attrs: { d: "M813.7 247.5H1333V968H813.7z" },
          }),
          _c("path", {
            staticStyle: { fill: "#a1e7fc" },
            attrs: { d: "M726 160h519.3v720.5H726z" },
          }),
          _c("path", {
            staticClass: "st4",
            attrs: {
              d: "M1152.4 290.4H981.6c-2.5 0-4.6-2-4.6-4.6 0-2.5 2.1-4.6 4.6-4.6h170.8c2.5 0 4.6 2 4.6 4.6 0 2.5-2 4.6-4.6 4.6zm-193.7 0h-22.9c-2.5 0-4.6-2-4.6-4.6 0-2.5 2.1-4.6 4.6-4.6h22.9c2.5 0 4.6 2 4.6 4.6 0 2.5-2 4.6-4.6 4.6zm-45.8 0H798.2c-2.5 0-4.6-2-4.6-4.6 0-2.5 2.1-4.6 4.6-4.6h114.6c2.5 0 4.6 2 4.6 4.6 0 2.5-2 4.6-4.5 4.6zM1152.4 438.2H981.6c-2.5 0-4.6-2-4.6-4.6s2.1-4.6 4.6-4.6h170.8c2.5 0 4.6 2 4.6 4.6s-2 4.6-4.6 4.6zm-193.7 0h-22.9c-2.5 0-4.6-2-4.6-4.6s2.1-4.6 4.6-4.6h22.9c2.5 0 4.6 2 4.6 4.6s-2 4.6-4.6 4.6zm-45.8 0H798.2c-2.5 0-4.6-2-4.6-4.6s2.1-4.6 4.6-4.6h114.6c2.5 0 4.6 2 4.6 4.6s-2 4.6-4.5 4.6zM1152.4 586H981.6c-2.5 0-4.6-2-4.6-4.6 0-2.5 2.1-4.6 4.6-4.6h170.8c2.5 0 4.6 2 4.6 4.6 0 2.5-2 4.6-4.6 4.6zm-193.7 0h-22.9c-2.5 0-4.6-2-4.6-4.6 0-2.5 2.1-4.6 4.6-4.6h22.9c2.5 0 4.6 2 4.6 4.6 0 2.5-2 4.6-4.6 4.6zm-45.8 0H798.2c-2.5 0-4.6-2-4.6-4.6 0-2.5 2.1-4.6 4.6-4.6h114.6c2.5 0 4.6 2 4.6 4.6 0 2.5-2 4.6-4.5 4.6zM1152.4 733.8H981.6c-2.5 0-4.6-2-4.6-4.6s2.1-4.6 4.6-4.6h170.8c2.5 0 4.6 2 4.6 4.6s-2 4.6-4.6 4.6zm-193.7 0h-22.9c-2.5 0-4.6-2-4.6-4.6s2.1-4.6 4.6-4.6h22.9c2.5 0 4.6 2 4.6 4.6s-2 4.6-4.6 4.6zm-45.8 0H798.2c-2.5 0-4.6-2-4.6-4.6s2.1-4.6 4.6-4.6h114.6c2.5 0 4.6 2 4.6 4.6s-2 4.6-4.5 4.6z",
            },
          }),
        ],
        1
      ),
      _c("g", [
        _c(
          "g",
          { attrs: { transform: "matrix(-2.39524 0 0 2.3925 730 380)" } },
          [
            _c("defs", [
              _c("path", {
                attrs: {
                  id: "SVGID_6_",
                  d: "M-497.4-944.8H707.4v2289.6H-497.4z",
                },
              }),
            ]),
            _c("clipPath", { attrs: { id: "SVGID_7_" } }, [
              _c("use", {
                staticStyle: { overflow: "visible" },
                attrs: { "xlink:href": "#SVGID_6_" },
              }),
            ]),
            _c(
              "g",
              { staticStyle: { "clip-path": "url(#SVGID_7_)" } },
              [
                _c(
                  "linearGradient",
                  {
                    attrs: {
                      id: "R_shoe-2-i3_1_",
                      gradientUnits: "userSpaceOnUse",
                      x1: "877.644",
                      y1: "-146.333",
                      x2: "-133.218",
                      y2: "-146.333",
                      gradientTransform:
                        "matrix(.4252 0 0 -.4242 -189.433 322.177)",
                    },
                  },
                  [
                    _c("stop", {
                      staticStyle: { "stop-color": "#23286b" },
                      attrs: { offset: "0" },
                    }),
                    _c("stop", {
                      staticStyle: { "stop-color": "#1d225f" },
                      attrs: { offset: ".432" },
                    }),
                    _c("stop", {
                      staticStyle: { "stop-color": "#151a4f" },
                      attrs: { offset: "1" },
                    }),
                  ],
                  1
                ),
                _c("path", {
                  staticStyle: { fill: "url(#R_shoe-2-i3_1_)" },
                  attrs: {
                    id: "R_shoe-2-i3",
                    d: "M198.7 368.5 210 400h-79.6s4.1-7.9 17.7-13.7 26.3-17.8 26.3-17.8h24.3",
                  },
                }),
                _c("path", {
                  staticClass: "st8",
                  attrs: {
                    id: "L_shoe-2-i3",
                    d: "m126.4 368.5 11.3 31.5H58s4.1-7.9 17.7-13.7 26.3-17.8 26.3-17.8h24.4",
                  },
                }),
                _c(
                  "linearGradient",
                  {
                    attrs: {
                      id: "R_trousers-2-i3_1_",
                      gradientUnits: "userSpaceOnUse",
                      x1: "883.652",
                      y1: "101.36",
                      x2: "-515.56",
                      y2: "-766.506",
                      gradientTransform:
                        "matrix(.4252 0 0 -.4242 -189.433 322.177)",
                    },
                  },
                  [
                    _c("stop", {
                      staticStyle: { "stop-color": "#1A7BEE" },
                      attrs: { offset: "0" },
                    }),
                    _c("stop", {
                      staticStyle: { "stop-color": "#009bd3" },
                      attrs: { offset: ".37" },
                    }),
                    _c("stop", {
                      staticStyle: { "stop-color": "#008ec6" },
                      attrs: { offset: ".999" },
                    }),
                  ],
                  1
                ),
                _c("path", {
                  staticStyle: { fill: "url(#R_trousers-2-i3_1_)" },
                  attrs: {
                    id: "R_trousers-2-i3",
                    d: "M198.7 368.5h-24.3s-49-86-52.6-105.1c-2.8-15.1-3.4-32.7-2.7-48.8l.4-48.2c20 3.6 34.6 3.9 45.1 2.7.5 13.9.2 30.3-3.8 43-11.4 36.8 8.5 41.2 15.1 54.2s7.7 18.7 10.1 31.1c2.7 14.2 10.7 18.4 13.7 32.6 3.9 19.5-1 38.5-1 38.5z",
                  },
                }),
                _c("path", {
                  staticClass: "st4",
                  attrs: {
                    id: "L_trousers-2-i3",
                    d: "M167.8 190.8c-11 40.7-11.9 35-10.2 63.6 1.7 28.6-3.8 19-5.5 49s-2.8 46.2-25.7 65.1h-24.3s-3.3-78.1-2.8-104c.5-23.1 4.4-61.9 6.4-78.3 4.3-10.6 6-4.9 11.6-9.7 3.1-2.5 5.6-5.6 7.4-9.1 21.1 3.4 35.7 2.9 45.7.9.3 7.6-.6 15.1-2.6 22.5z",
                  },
                }),
                _c("path", {
                  staticStyle: {
                    opacity: ".86",
                    fill: "#fff",
                    "enable-background": "new",
                  },
                  attrs: {
                    id: "texture-2-i3",
                    d: "M148 175.7c-.1 0-.2 0-.3.1 0 .1 0 .2.1.3.1 0 .2 0 .3-.1 0-.2 0-.3-.1-.3zm-4.6-1.9c-.1 0-.2 0-.3.1 0 .1 0 .2.1.3.1 0 .2 0 .3-.1s0-.3-.1-.3zm-4.5-1.9c-.1 0-.2 0-.3.1s0 .2.1.3c.1 0 .2 0 .2-.1.1-.1.1-.2 0-.3zm-4.6-1.9c-.1 0-.2 0-.3.1 0 .1 0 .2.1.2s.2 0 .3-.1c0 0 0-.1-.1-.2zm-.9 20.5c0-.1-.2-.1-.3-.1s-.1.2-.1.3.2.1.3.1c.1 0 .2-.2.1-.3zm-1.8-4.5c0-.1-.1-.1-.2-.1s-.2.2-.1.3c.1.1.2.1.3.1-.1-.1 0-.2 0-.3zm-1.9-4.6c0-.1-.2-.2-.3-.1-.1.1-.1.2-.1.3s.2.1.3.1c0 0 .1-.2.1-.3zm-2-4.5c0-.1-.2-.1-.3-.1-.1.1-.2.2-.1.3 0 .1.2.1.3.1.1-.1.2-.2.1-.3zm-15.1 13.6c-.1 0-.2 0-.3.1 0 .1 0 .2.1.3.1 0 .2 0 .3-.1s0-.3-.1-.3zm27.8-8c-.1-.1-.2-.1-.3 0s-.1.2 0 .3.2.1.3 0c.1-.1.1-.2 0-.3zm-3.5-3.5c-.1-.1-.2-.1-.3 0l-.1.1c0 .1 0 .1.1.2h.2c.2 0 .2-.2.1-.3zm-3.5-3.4c-.1-.1-.2-.1-.3 0s-.1.2 0 .3c.1.1.2.1.3 0s.1-.3 0-.3zm-3.5-3.5c-.1-.1-.2-.1-.3 0s-.1.2 0 .3c.1.1.2.1.3 0 .1-.1.1-.2 0-.3zm-7 17.8c-.1 0-.2.1-.2.2s.1.2.2.2.2-.1.2-.2 0-.2-.2-.2zm0-4.9c-.1 0-.2.1-.2.2s.1.2.2.2.2-.1.2-.2-.1-.2-.2-.2zm37.3 6.5c-.2-.1-.4-.1-.5 0-.1.2-.1.4 0 .5.2.1.4.1.5 0 .2-.1.2-.4 0-.5zm-7.1-6.2c-.2-.1-.4-.1-.5 0-.1.2-.1.4 0 .6.2.1.4.1.6 0 .1-.2.1-.4-.1-.6zm-7-6.1c-.2-.1-.4-.1-.6 0s-.1.4 0 .6c.2.1.4.1.6 0 .1-.2.1-.4 0-.6zm-7.1-6.1c-.2-.1-.4-.1-.5 0-.1.1-.1.2-.1.4 0 .1.1.1.1.2l.1.1c.2.1.4 0 .5-.2.1-.3 0-.4-.1-.5zm-7.3 42c-.2 0-.4.2-.4.4s.2.4.4.4.4-.2.4-.4-.1-.4-.4-.4zm-.6-9.3c-.2 0-.4.2-.4.4s.2.4.4.4.4-.2.4-.4c0-.3-.2-.4-.4-.4zm-.7-9.4c-.2 0-.4.2-.4.4s.2.4.4.4.4-.2.4-.4-.2-.4-.4-.4zm-.6-9.3c-.2 0-.4.2-.4.4s.2.4.4.4.4-.2.4-.4-.2-.4-.4-.4zm-.7-9.3c-.2 0-.4.2-.4.4s.2.4.4.4.4-.2.4-.4c0-.3-.2-.5-.4-.4zm35.2-2.4c-.2-.1-.4 0-.5.2s0 .4.2.5.4 0 .5-.2 0-.4-.2-.5zm-8.9-3c-.2-.1-.4 0-.5.2-.1.2 0 .4.2.5s.4 0 .5-.2c.1-.2 0-.4-.2-.5zm-8.9-2.9c-.2-.1-.4 0-.5.2-.1.2 0 .4.2.5.2.1.4 0 .5-.2.1-.3 0-.5-.2-.5zm3.6 36.3c-.1-.2-.3-.3-.5-.2s-.3.3-.2.5.3.3.5.2c.2-.1.3-.3.2-.5zm-4.2-8.4c-.1-.2-.3-.3-.5-.2s-.3.3-.2.5.3.3.5.2c.2 0 .3-.3.2-.5zm-4.1-8.3c-.1-.2-.3-.3-.5-.2s-.3.3-.2.5.3.3.5.2.2-.4.2-.5zm-4.2-8.4c-.1-.2-.3-.3-.5-.2s-.3.3-.2.5c.1.2.3.3.5.2.2-.1.3-.3.2-.5zm-4.2-8.4c-.1-.2-.3-.3-.5-.2s-.3.3-.2.5.3.3.5.2.3-.3.2-.5zm-19.2 36.1c-.2-.1-.4 0-.5.2-.1.2 0 .4.2.5.2.1.4 0 .5-.2.1-.2 0-.4-.2-.5zm3-8.8c-.2-.1-.4 0-.5.2-.1.2 0 .4.2.5s.4-.1.5-.3c.1-.2 0-.4-.2-.4zm2.9-8.9c-.2-.1-.4 0-.5.2s0 .4.2.5c.2.1.4 0 .5-.2.1-.2 0-.5-.2-.5zm3-8.9c-.2-.1-.4.1-.5.3s0 .4.2.5c.2.1.4 0 .5-.2.1-.3 0-.6-.2-.6zm46.8-10.8-.1.1c0 .1 0 .2.1.3-.1-.2-.1-.3 0-.4zm-11.8 30.5c-.1-.2-.3-.2-.5-.1s-.2.3-.1.5.3.2.5.1.2-.3.1-.5zm-4.4-7c-.1-.2-.3-.2-.5-.1s-.2.3-.1.5.3.2.5.1c.2-.2.2-.4.1-.5zm-4.4-7.1c0-.1-.1-.1-.1-.1h-.3c-.2.1-.2.3-.1.5s.3.2.5.1c.1 0 .1-.1.1-.2 0-.2-.1-.3-.1-.3zm-4.4-7.1c-.1-.2-.3-.2-.5-.1s-.2.3-.1.5.3.2.5.1c.1-.2.2-.4.1-.5zm-4.5-7.1c-.1-.2-.3-.2-.5-.1s-.2.3-.1.5.3.2.5.1.2-.4.1-.5zm-17.1 34c-.2 0-.4.1-.4.3 0 .2.1.4.2.4.2 0 .4-.1.4-.3.1-.2-.1-.4-.2-.4zm1.8-8.2c-.2 0-.4.1-.4.3 0 .2.1.4.2.4.2 0 .4-.1.4-.3.1-.1 0-.3-.2-.4zm1.9-8.1c-.2 0-.4.1-.4.3-.1.2 0 .4.2.4s.4-.1.4-.3c.1-.2 0-.4-.2-.4zm1.9-8.2c-.2 0-.4.1-.4.3s.1.4.3.4.4-.1.4-.3c0-.1-.1-.3-.3-.4zm1.9-8.1c-.2 0-.4.1-.4.3s.1.4.3.4.4-.1.4-.3-.1-.3-.3-.4zm30.6 6.9c-.2-.1-.4-.1-.5.1-.1.1-.1.3.1.5.1.1.4.1.5-.1.1-.1.1-.4-.1-.5zm-6.8-4.8c-.2-.1-.4-.1-.5.1-.1.2-.1.4.1.5.2.1.4.1.5-.1.1-.2.1-.4-.1-.5zm-6.8-4.9c-.2-.1-.4-.1-.5.1-.1.2-.1.4.1.5.2.1.4.1.5-.1.1-.2.1-.4-.1-.5zm-6.8 31.7c-.2 0-.3.2-.3.4s.2.3.4.3.3-.2.3-.4-.2-.3-.4-.3zm-1.4-8.3c-.2 0-.3.2-.3.4s.2.3.4.3.3-.2.3-.4c0-.1-.2-.3-.4-.3zm-1.3-8.2c-.2 0-.3.2-.3.4s.2.3.4.3.3-.2.3-.4c-.1-.2-.2-.3-.4-.3zm-1.4-8.2c-.2 0-.3.2-.3.4 0 .1 0 .1.1.2s.2.1.3.1c.2 0 .3-.2.3-.4s-.2-.4-.4-.3zm-1.4-8.3c-.1 0-.1 0-.2.1 0 .1-.1.1-.1.2v.1c0 .2.2.3.4.3s.3-.2.3-.4-.2-.3-.4-.3zm-25.4 26.1c-.2-.1-.4-.1-.5.1-.1.2-.1.4.1.5.1.1.3.1.5-.1.1-.1.1-.4-.1-.5zm4.8-6.8c-.2-.1-.4-.1-.5.1-.1.2-.1.4.1.5s.4.1.5-.1c.1-.2.1-.4-.1-.5zm14.6-20.4c-.2-.1-.4-.1-.5.1-.1.2-.1.4.1.5.2.1.4.1.5-.1.1-.2 0-.4-.1-.5zm28 11.6c-.1-.1-.2-.1-.3 0s-.1.2 0 .3.2.1.3 0c.1-.1.1-.2 0-.3zm-3.4-3.6c-.1-.1-.2-.1-.3 0s-.1.2 0 .3.2.1.3 0c.1-.1.1-.2 0-.3zm-3.3-3.6c-.1-.1-.2-.1-.3 0s-.1.2 0 .3c.1.1.2.1.3 0 0-.1.1-.2 0-.3zm-3.4-3.6c-.1-.1-.2-.1-.3 0s-.1.2 0 .3c.1.1.2.1.3 0s.1-.2 0-.3zm-9.5 18c-.1 0-.2.1-.2.2s.1.2.2.2.2-.1.2-.2-.1-.2-.2-.2zm.2-4.9c-.1 0-.2.1-.2.2s.1.2.2.2.2-.1.2-.2-.1-.2-.2-.2zm.2-4.9c-.1 0-.2.1-.2.2s.1.2.2.2.2-.1.2-.2-.1-.2-.2-.2zm.1-5c-.2 0-.2.1-.2.2s.1.2.2.2.2-.1.2-.1v-.1c0-.1 0-.1-.2-.2zm-8.4-3.8c-.1-.1-.2-.1-.3 0s-.1.2 0 .3.2.1.3 0 .1-.2 0-.3zm31.4 1.4c-.1 0-.2 0-.3.1 0 .1 0 .2.1.3.1 0 .2 0 .3-.1 0-.2 0-.3-.1-.3zm-13.6 13.1c0-.1-.1-.2-.2-.1-.1 0-.2.1-.1.3 0 .1.2.2.3.1v-.3zm-1.7-4.6c0-.1-.2-.1-.3-.1-.1 0-.2.2-.1.3 0 .1.2.2.3.1.1-.1.1-.2.1-.3zm-1.8-4.7c0-.1-.2-.2-.3-.1-.1 0-.2.2-.1.3 0 .1.1.2.2.1.2 0 .3-.2.2-.3.1 0 .1 0 0 0zm-1.7-4.6c0-.1-.2-.2-.3-.1-.1 0-.2.2-.1.3 0 .1.1.2.2.1.2-.1.3-.2.2-.3zm-13.7 13.3c-.1 0-.2 0-.3.1 0 .1 0 .2.1.3s.2 0 .3-.1c0-.2 0-.3-.1-.3zm2-4.5c-.1 0-.2 0-.3.1 0 .1 0 .2.1.3.1 0 .2 0 .3-.1 0-.1 0-.3-.1-.3zm2-4.5c-.1 0-.2 0-.3.1s0 .2.1.3.2 0 .3-.1c.1-.1 0-.3-.1-.3zm2.2-4.4c0-.1-.1-.1-.1-.1-.1 0-.2 0-.3.1v.1c0 .1.1.1.1.2.1 0 .2 0 .3-.1v-.2zm26 15.8c-.1-.1-.2-.1-.3-.1-.1.1-.1.2-.1.3.1.1.2.1.3.1.1-.1.1-.2.1-.3zm-3.1-4.8c-.1-.1-.2-.1-.3-.1-.1.1-.1.2-.1.3.1.1.2.1.3.1.2 0 .2-.2.1-.3zm-3-4.7c-.1-.1-.2-.1-.3-.1-.1.1-.1.2-.1.3.1.1.2.1.3 0 .2 0 .2-.1.1-.2zm-3-4.8c-.1 0-.1 0 0 0-.2-.1-.3-.1-.3-.1-.1.1-.1.2-.1.3.1.1.2.1.3.1.1 0 .2-.1.1-.3zm-14.4 18.3c-.1 0-.2.1-.3.2 0 .1 0 .2.2.3.1 0 .2 0 .3-.1 0-.2 0-.3-.2-.4zm1.2-5.5c-.1 0-.2.1-.3.2 0 .1 0 .2.2.3.1 0 .3 0 .3-.2 0-.1 0-.2-.2-.3zm1.2-5.5c-.1 0-.2.1-.3.2 0 .1 0 .2.2.3.1 0 .2 0 .3-.1 0-.2 0-.3-.2-.4zm1.2-5.5c-.1 0-.2.1-.3.2 0 .1 0 .2.2.3.1 0 .2 0 .3-.1 0-.2 0-.3-.2-.4zm26.1 2.1c-.1-.1-.2-.1-.3 0-.1.1 0 .2.1.3s.2 0 .3-.1c.1 0 0-.1-.1-.2zm-4.6-3.2c-.1-.1-.2-.1-.3.1-.1.1 0 .3.1.3.1.1.2 0 .3-.1.1-.1 0-.2-.1-.3zm-13.3 15.1c0-.1-.1-.2-.3-.2-.1 0-.2.1-.2.3 0 .1.1.2.3.2h.1c.1-.1.1-.2.1-.3zm-1.2-5.7c-.1 0-.2.2-.2.3s.2.2.3.2.2-.1.2-.3c-.1-.2-.2-.3-.3-.2zm-1-5.6c-.1 0-.2.1-.2.3 0 .1.1.2.3.2.1 0 .2-.1.2-.3-.1-.1-.2-.2-.3-.2zm-1-5.5c-.1 0-.2.1-.2.3 0 .1.1.2.2.2s.2-.1.2-.3c0-.1-.1-.2-.2-.2zm-17.9 12.2c-.1-.1-.2 0-.3.1-.1.1 0 .2.1.3s.2.1.3 0c0-.2 0-.3-.1-.4zm3.2-4.6c-.1-.1-.3 0-.3.1-.1.1 0 .2.1.3.1.1.2.1.3 0 0-.2 0-.3-.1-.4zm3.2-4.6c-.1-.1-.2 0-.3.1-.1.1 0 .3.1.3.1.1.2 0 .3-.1 0-.1 0-.3-.1-.3zm34.6-1.2c-.2-.1-.4-.1-.6.1-.1.2-.1.4.1.6.2.1.4.1.6-.1.1-.2.1-.5-.1-.6zm-11.6 38.2c-.2 0-.4.2-.3.5 0 .2.2.4.5.3.2 0 .4-.2.3-.5 0-.2-.2-.4-.5-.3zm-1.5-9.6c-.2 0-.4.2-.3.5 0 .2.2.4.5.3.2 0 .4-.2.3-.5 0-.2-.2-.3-.5-.3zm-1.5-9.5c-.2 0-.4.2-.3.4s.2.4.4.3c.2 0 .4-.2.3-.5.1-.1-.1-.2-.4-.2zm-1.5-9.5c-.2 0-.4.2-.3.4 0 .2.2.4.5.3.2 0 .4-.2.3-.5 0-.1-.2-.3-.5-.2zm-1.4-9.6c-.2 0-.4.2-.3.5 0 .2.2.4.4.3.2 0 .4-.2.3-.5 0-.2-.2-.3-.4-.3zm-33.2 28.7c-.2-.1-.4-.1-.6.1-.1.2-.1.4.1.6.2.1.4.1.6-.1.1-.2.1-.5-.1-.6zm5.7-7.8c-.2-.1-.4-.1-.6.1-.1.2-.1.4.1.6.2.1.4.1.6-.1.1-.2 0-.5-.1-.6zm5.6-7.8c-.2-.1-.4-.1-.5.1-.1.2-.1.4.1.6.2.1.4.1.6-.1 0-.2 0-.5-.2-.6zm5.7-7.8c-.2-.1-.4-.1-.5.1-.1.2-.1.4.1.6.2.1.4.1.6-.1 0-.2 0-.5-.2-.6zm5.7-7.8c-.2-.1-.4-.1-.6.1-.1.2-.1.4.1.6.2.1.4.1.6-.1.1-.2.1-.5-.1-.6zm24.2 13.2c-.1-.2-.4-.2-.6-.1-.2.1-.2.4-.1.6.1.2.4.2.6.1.2-.1.2-.4.1-.6zm-5-8.2c-.1-.2-.4-.3-.5-.1-.2.1-.2.4-.1.6.1.2.4.2.6.1.1-.2.1-.4 0-.6zm-21.6 30.6c-.2-.1-.4.1-.5.3-.1.2.1.4.3.5.2 0 .4-.1.5-.3.1-.3 0-.5-.3-.5zm2.3-9.4c-.2-.1-.4.1-.5.3-.1.2.1.4.3.5.2.1.4-.1.5-.3.1-.2-.1-.4-.3-.5zm2.3-9.4c-.2 0-.4.1-.5.3 0 .2.1.4.3.5s.4-.1.5-.3c0-.2-.1-.4-.3-.5zm2.2-9.4c-.2 0-.4.1-.5.3 0 .2.1.4.3.5.2 0 .4-.1.5-.3s-.1-.4-.3-.5zm-11.8-8.3c-.1-.2-.4-.2-.6-.1-.2.1-.2.4-.1.6.1.2.4.2.5.1.2-.1.3-.4.2-.6 0 .1 0 .1 0 0zm34.7 7.8c-.1-.2-.4-.2-.5-.1-.2.1-.2.4-.1.6.1.2.4.2.6.1.1-.1.1-.4 0-.6zm-23.8 31.8c-.2 0-.4.1-.5.3 0 .2.1.4.3.5.2 0 .4-.1.5-.3 0-.3-.1-.5-.3-.5zm1.8-9.4c-.2 0-.4.1-.5.3 0 .2.1.4.3.5.2 0 .4-.1.5-.3.1-.3-.1-.5-.3-.5zm1.9-9.5c-.2 0-.4.1-.5.3 0 .2.1.4.3.5.2 0 .4-.1.5-.3 0-.2-.1-.4-.3-.5zm1.8-9.4c-.2 0-.4.1-.5.3 0 .2.1.4.3.5.2 0 .4-.1.5-.3.1-.3 0-.5-.3-.5zm1.9-9.4c-.2 0-.4.1-.5.3 0 .1 0 .3.1.4h.1l.1.1c.2 0 .4-.1.5-.3.1-.3-.1-.5-.3-.5zm-24.9 4.7c-.1-.2-.3-.2-.5-.1s-.2.4-.1.5c.1.2.4.2.6.1.1-.1.2-.3 0-.5zm8-5.3c-.1-.1-.1-.1-.2-.1s-.2 0-.3.1c0 0-.1 0-.1.1-.2.2-.2.4 0 .6.1.1.4.2.5 0 .1 0 .1-.1.1-.2.1-.3.1-.4 0-.5zm27.4 23.7c-.2 0-.4.3-.3.5 0 .2.3.4.5.3.2 0 .4-.2.3-.5-.1-.2-.3-.4-.5-.3zm-1.9-9.5c-.2 0-.4.3-.3.5 0 .2.2.4.5.3.2 0 .4-.2.3-.5-.1-.2-.3-.3-.5-.3zm-1.9-9.4c-.2 0-.4.3-.3.5.1.2.3.4.5.3.2 0 .3-.2.3-.5 0-.2-.3-.3-.5-.3zm-30.1 21.5c-.2-.1-.4-.1-.5.1-.1.2-.1.4.1.5.2.1.4.1.6-.1 0-.1 0-.4-.2-.5zm5.3-8c-.2-.1-.4-.1-.5.1-.1.2-.1.4.1.5.2.1.4.1.6-.1 0-.1 0-.4-.2-.5zm5.3-8c-.2-.1-.4-.1-.5.1-.1.2-.1.4.1.5.2.1.4.1.6-.1.1-.1 0-.4-.2-.5zm5.3-8c-.2-.1-.4-.1-.5.1-.1.2-.1.4.1.5.2.1.4.1.6-.1.1-.1 0-.4-.2-.5zm22.6-.2c-.1-.1-.2-.2-.4-.2-.2.1-.2.2-.2.4.1.2.2.2.4.2s.2-.2.2-.4zm-22.6 19.7c-.1-.1-.3 0-.4.1-.1.2 0 .3.2.4s.3 0 .4-.2c0-.1 0-.3-.2-.3zm2.9-6.7c-.1-.1-.3 0-.4.1-.1.2 0 .3.2.4.2.1.3 0 .4-.2 0 0-.1-.2-.2-.3zm2.8-6.7c-.2-.1-.3 0-.4.2-.1.2 0 .3.2.4.2.1.3 0 .4-.2 0-.1 0-.3-.2-.4zm2.9-6.6c-.2-.1-.3 0-.4.2-.1.2 0 .3.2.4.1.1.3 0 .4-.1 0-.3-.1-.5-.2-.5zm6.6 19.3c-.2 0-.3.1-.3.3 0 .2.1.3.3.3s.3-.1.3-.3c0-.1-.1-.3-.3-.3zm.1-7.2c-.2 0-.3.1-.3.3 0 .2.1.3.3.3.2 0 .3-.1.3-.3s-.1-.3-.3-.3zm.1-7.3c-.2 0-.3.1-.3.3s.1.3.3.3c.2 0 .3-.1.3-.3 0-.1-.1-.3-.3-.3zm.1-7.2c-.2 0-.3.1-.3.3 0 .2.1.3.3.3.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3zm-25.6 11.1c-.1-.1-.3-.1-.4 0-.1.1-.1.3 0 .4.1.1.3.1.4 0 .1-.1.1-.3 0-.4zm5.2-5.1c-.1-.1-.3-.1-.4 0-.1.1-.1.3 0 .4.1.1.3.1.4 0 .1 0 .1-.2 0-.4zm5.2-5c-.1-.1-.3-.1-.4 0-.1.1-.1.3 0 .4.1.1.3.1.4 0 .1-.1.1-.3 0-.4zm16.9 4.9c-.1 0-.2 0-.2.1s0 .2.1.2.2-.1.2-.1c.1-.1 0-.2-.1-.2zm.7-3.9c-.1 0-.2 0-.2.1s0 .2.1.2.2 0 .2-.1 0-.2-.1-.2zm6.6-2.3c-.1 0-.1.1-.1.2s.1.1.2.1.1-.1.1-.2c-.1-.1-.2-.1-.2-.1zm-14 1.4c-.1 0-.2 0-.2.1-.1.1 0 .2.1.2s.2 0 .2-.1 0-.2-.1-.2zm2.1 11c-.1-.1-.3 0-.4.1-.1.1-.1.3.1.3.1.1.3.1.4-.1.1-.1.1-.2-.1-.3zm3.5-5.6c-.1-.1-.3 0-.4.1-.1.1 0 .3.1.4.1.1.3 0 .4-.1.1-.1.1-.3-.1-.4zm3.5-5.5c-.1-.1-.3 0-.4.1-.1.1 0 .3.1.4.1.1.3 0 .4-.1.1-.2 0-.4-.1-.4zm-14.2-.5c-.1-.1-.3-.1-.4 0-.1.1-.1.2-.1.4.1.1.2.2.4.1.1-.2.2-.3.1-.5z",
                  },
                }),
                _c(
                  "linearGradient",
                  {
                    attrs: {
                      id: "sweater-2-i3_1_",
                      gradientUnits: "userSpaceOnUse",
                      x1: "738.769",
                      y1: "587.671",
                      x2: "500.125",
                      y2: "-820.316",
                      gradientTransform:
                        "matrix(.4252 0 0 -.4242 -189.433 322.177)",
                    },
                  },
                  [
                    _c("stop", {
                      staticStyle: { "stop-color": "#23286b" },
                      attrs: { offset: "0" },
                    }),
                    _c("stop", {
                      staticStyle: { "stop-color": "#151a4f" },
                      attrs: { offset: "1" },
                    }),
                  ],
                  1
                ),
                _c("path", {
                  staticStyle: { fill: "url(#sweater-2-i3_1_)" },
                  attrs: {
                    id: "sweater-2-i3",
                    d: "M82.5 57.9c14.2 1.9 27.8 6.7 40 14.1 20.7 12.5 21.1 20.7 32.7 28.3 11.6 7.6 42.7 20.9 35.9 56.8 0 0-10.1 21.9-78.9 7.8l-43.8-97s9.2 0 14.1-10z",
                  },
                }),
                _c(
                  "linearGradient",
                  {
                    attrs: {
                      id: "R_hand-2-i3_1_",
                      gradientUnits: "userSpaceOnUse",
                      x1: "537.958",
                      y1: "427.137",
                      x2: "134.544",
                      y2: "-367.084",
                      gradientTransform:
                        "matrix(.3981 .148 .1477 -.3972 -236.022 275.209)",
                    },
                  },
                  [
                    _c("stop", {
                      staticStyle: { "stop-color": "#ffbeb6" },
                      attrs: { offset: "0" },
                    }),
                    _c("stop", {
                      staticStyle: { "stop-color": "#f2a19c" },
                      attrs: { offset: "1" },
                    }),
                  ],
                  1
                ),
                _c("path", {
                  staticStyle: { fill: "url(#R_hand-2-i3_1_)" },
                  attrs: {
                    id: "R_hand-2-i3",
                    d: "M65.2 165s-8.8 11.9-17.1 18.2-9.3 5.9-14.2 3.2c-4.5-2.6-8.8-5.6-12.8-9-1.7-1.6-5-.5-2.5 4.3 2.5 4.9 10.5 5.3 8.5 8.9-2 3.6-11.8 7.7-19.4 10s-11.7 3.7-1.9 10.7c9.8 6.9 19.6 9.6 37.6-6.6s33.4-20 41-21.9L65.2 165z",
                  },
                }),
                _c("path", {
                  staticClass: "st8",
                  attrs: {
                    id: "L_sleeve-i3",
                    d: "M68.6 68.4S83.2 94 87 112.6s3.3 25.4-7.8 37.4c-8.7 9.4-16.9 17.4-16.9 17.4l27 47.8s17.3-7.6 21.9-22.9c5.2-17.2 12.7-19.9 20.2-24.8 7.5-4.8 21.5-20 9.7-46.5S114 76.1 79.7 55.2",
                  },
                }),
                _c(
                  "linearGradient",
                  {
                    attrs: {
                      id: "neck-2-i3_1_",
                      gradientUnits: "userSpaceOnUse",
                      x1: "592.333",
                      y1: "588.096",
                      x2: "386.909",
                      y2: "959.615",
                      gradientTransform:
                        "matrix(.4252 0 0 -.4242 -189.433 322.177)",
                    },
                  },
                  [
                    _c("stop", {
                      staticStyle: { "stop-color": "#ffbeb6" },
                      attrs: { offset: "0" },
                    }),
                    _c("stop", {
                      staticStyle: { "stop-color": "#f2a19c" },
                      attrs: { offset: "1" },
                    }),
                  ],
                  1
                ),
                _c("path", {
                  staticStyle: { fill: "url(#neck-2-i3_1_)" },
                  attrs: {
                    id: "neck-2-i3",
                    d: "M60.7 55.2c3.3 4.3 6.1 9 8.3 14.1 0 0 8.2 1.4 12.6-11.7l-13-12.8-7.9 10.4",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#ffbeb6" },
                  attrs: {
                    id: "face-2-i3",
                    d: "M39.8 26.5v.4c-.1.5-.1 1-.1 1.6-.3 5.8-4 10.5-3.9 12.1s3.3 2.4 4.8 2.4 3.8 7.2 10.1 10.9c5.9 3.5 14.3 2.3 19.5-1.2 1.2-12.4-1.2-18-13.4-22.5-13.3-4.9-13.4-13.4-13.4-13.4-1.9 2.8-3.1 6.2-3.6 9.7z",
                  },
                }),
                _c("path", {
                  staticStyle: { fill: "#e94766" },
                  attrs: {
                    id: "hair-2-i3",
                    d: "M97.9 29.1c-3.4-5.6-5.3-13-6.2-15.7C90.5 9.7 81.6-1.3 67.5.1S36.1 7.9 39.8 26.8c.4-3.6 1.7-7.1 3.7-10.2 0 0 0 8.5 13.3 13.4 1.4.5 2.8 1.1 4.1 1.7 6.7 6.7 10.5 15.1 4.2 24.9-.4.6.5 1.1.9.5 5.8-9.1 3.3-17.2-2.2-23.8 6.9 4.6 7.6 10.9 6 22.7 0 0 21.7 2.8 39.6-11.1-1.1-4.3-3.6-8.1-7.2-10.7-1.2-1-2.3-2.2-3.2-3.5 5.5 3.6 11.5 6.7 11.6 13.8 0 .3.2.5.5.5s.5-.2.5-.5c-.1-8.2-7.7-11.2-13.7-15.4z",
                  },
                }),
                _c("path", {
                  staticClass: "st4",
                  attrs: {
                    id: "eyeglasses-i3",
                    d: "M37.3 36.1c.1 0 .1-.1 0 0 .2-.3.3-.4.4-.6.1-.1.1-.2.2-.3.3-.5.6-.9.9-1.4.6-1.2.9-2.4 1-3.7v-.6c1.5-.6 3.1.3 4.3 1.1 0 1.4.2 2.8.7 4.2.6 1.8 1.8 3.2 3.4 4.2 1.4.8 3.1.8 4.4 0 .3-.2.6-.4.8-.6 1-1 1.7-2.3 1.9-3.7.4-2 .2-4-.5-5.9-1.5-4-5.1-5.9-7.9-4.2-1.5 1-2.5 2.6-2.8 4.3 0 .2-.1.4-.1.6-1.3-1-3-1.4-4.6-.9-.1-.4-.2-.8-.4-1.2-1.3-3.4-4.4-5.1-6.8-3.6-2.4 1.4-3.3 5.4-2 8.8 1.6 3.3 4.7 4.9 7.1 3.5zm7.8-7.2c.2-1.2.8-2.2 1.6-3.1.2-.2.4-.4.7-.5 2.4-1.4 5.4.3 6.7 3.8.7 1.7.8 3.5.5 5.3-.2 1.5-1.1 2.8-2.3 3.6-1.1.7-2.6.7-3.7 0-1.4-.9-2.5-2.2-3-3.7-.6-1.8-.8-3.6-.5-5.4zM31.3 32c-1.1-2.9-.5-6.3 1.5-7.5s4.5.2 5.6 3.2c1.1 2.9.5 6.3-1.5 7.5-1.9 1.1-4.5-.3-5.6-3.2z",
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }